<template>
  <div class="main-container">
    <div class="bread">
      <ExamIndexBread></ExamIndexBread>
      <span class="slash">/</span>
      <span class="current">仿真模考</span>
    </div>
    <div class="select-tab">
      <div class="item">
        <div class="left">
          <p>考试类型：</p>
        </div>
        <div class="right">
          <ul>
            <li :class="exam_type == 0 ? 'active' : ''" @click="changeType(0)">
              全部
            </li>
            <li :class="exam_type == 2 ? 'active' : ''" @click="changeType(2)">
              正式考试
            </li>
            <li :class="exam_type == 1 ? 'active' : ''" @click="changeType(1)">
              模拟考试
            </li>
          </ul>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <p>考试状态：</p>
        </div>
        <div class="right">
          <ul>
            <li
              :class="start_status == 0 ? 'active' : ''"
              @click="changeStatus(0)"
            >
              全部
            </li>
            <li
              :class="start_status == 2 ? 'active' : ''"
              @click="changeStatus(2)"
            >
              未开始
            </li>
            <li
              :class="start_status == 1 ? 'active' : ''"
              @click="changeStatus(1)"
            >
              进行中
            </li>
            <li
              :class="start_status == 3 ? 'active' : ''"
              @click="changeStatus(3)"
            >
              已结束
            </li>
          </ul>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <p>参考状态：</p>
        </div>
        <div class="right">
          <ul>
            <li
              :class="done_status == 0 ? 'active' : ''"
              @click="changeDone(0)"
            >
              全部
            </li>
            <li
              :class="done_status == 1 ? 'active' : ''"
              @click="changeDone(1)"
            >
              已考
            </li>
            <li
              :class="done_status == 2 ? 'active' : ''"
              @click="changeDone(2)"
            >
              未考
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clear list">
      <ExamSimulationItem
        v-for="item in list"
        :key="item.id"
        :item="item"
        :showName="true"
      ></ExamSimulationItem>
    </div>
    <el-pagination
      background
      @current-change="handlePageChange"
      :current-page="page"
      :page-size="limit"
      layout="prev, pager, next"
      :total="total"
      v-if="total > limit"
    ></el-pagination>
  </div>
</template>
<script>
import ExamSimulationItem from "../../components/ExamSimulationItem.vue";
import ExamIndexBread from "./components/ExamIndexBread.vue";

export default {
  name: "ExamSimulation",
  components: {
    ExamSimulationItem,
    ExamIndexBread,
  },
  data() {
    return {
      exam_type: 0,
      start_status: 0,
      done_status: 0,
      list: [],
      page: 1,
      limit: 6,
      total: 0,
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      let data = await this.$http.get(
        "/api/app/exam/packageSimulation?exam_type=" +
          this.exam_type +
          "&start_status=" +
          this.start_status +
          "&done_status=" +
          this.done_status,
        {
          page: this.page,
          limit: this.limit,
        },
      );
      this.list = data.list;
      this.total = data.total;
    },
    async changeType(type) {
      this.exam_type = type;
      this.page = 1;
      await this.getData();
    },
    async changeStatus(status) {
      this.start_status = status;
      this.page = 1;
      await this.getData();
    },
    async changeDone(done) {
      this.done_status = done;
      this.page = 1;
      await this.getData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.list {
  background-color: white;
  margin-top: 30px;
  padding: 24px;
  margin-bottom: 50px;
  padding-bottom: 0;
}
</style>
